type Project = {
  name: string;
  logo?: string;
  url?: string;
  currency?: string;
  tvl?: string;
  usecases: string[];
  address?: string;
};

export const projects: Project[] = [
  {
    name: 'Opinion Labs',
    url: 'https://app.olab.xyz/detail?topicId=273',
    logo: '/defi/olab.svg',
    usecases: ['collateral'],
  },
  {
    name: 'Narwhal Finance',
    url: 'https://testnet.narwhal.finance/?token=aprMON',
    logo: '/defi/narwhal.svg',
    usecases: ['collateral', 'lp'],
  },
  {
    name: 'PancakeSwap',
    url: 'https://pancakeswap.finance/swap?chain=monadTestnet&outputCurrency=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A',
    logo: 'https://i.imgur.com/8GCF5zE.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'LFJ',
    url: 'https://pandaria.lfj.gg/monad-testnet/trade/0xb2f82d0f38dc453d596ad40a37799446cc89274a',
    logo: 'https://i.imgur.com/rjJgxB5.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Izumi Finance',
    url: 'https://alpha.izumi.finance/trade/swap',
    logo: '/defi/izumi.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Rysk Finance',
    url: 'https://app.rysk.finance/earn/aprMON/',
    logo: 'https://i.imgur.com/86lSXSN.png',
    usecases: ['options'],
  },
  {
    name: 'Ammalgam',
    url: 'https://alpha.ammalgam.xyz/monad-testnet/pools/0x7DD6D345caa896bB07D9D6414ec9461388176E44/trade?action=swap',
    logo: '/defi/ammalgam.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Townesquare',
    url: 'https://www.townesquare.xyz/explore/1',
    logo: 'https://i.imgur.com/WkhenV2.png',
    usecases: ['staking'],
  },
  {
    name: 'Likwid',
    url: 'https://likwid.fi/trade/swap',
    logo: 'https://i.imgur.com/NAiK7wU.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Folks Finance',
    url: 'https://testnet.xapp.folks.finance/deposit',
    logo: 'https://i.imgur.com/5YgNf5Q.png',
    usecases: ['lending/borrowing'],
  },
  {
    name: 'Covenant',
    url: 'https://fluidtest.covenant.finance/market/7?action=buy&network=10143',
    logo: 'https://i.imgur.com/VSiGaYF.jpeg',
    usecases: ['staking'],
  },
  {
    name: 'Sumer',
    url: 'https://app.sumer.money/market/detail/0xb2f82d0f38dc453d596ad40a37799446cc89274a?chain=10143',
    logo: 'https://i.imgur.com/WIFxx7F.png',
    usecases: ['lending/borrowing'],
  },
  {
    name: 'Bean DEX',
    url: 'https://swap.bean.exchange/?outputCurrency=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A',
    logo: 'https://i.imgur.com/8vrcTox.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'BubbleFi',
    url: 'https://app.bubblefi.xyz/?currency0=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A&currency1=MON',
    logo: 'https://i.imgur.com/6Jx3wYu.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Purps',
    url: 'https://app.purps.xyz/stake',
    logo: '/defi/purps.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Sherpa',
    url: 'https://app.sherpa.trade/trade/swap',
    logo: 'https://i.imgur.com/guU7kIU.png',
    usecases: ['swap', 'lp', 'strategy'],
  },
  {
    name: 'AZEX',
    url: 'https://testnet.azex.io/perp',
    logo: '/defi/azex.svg',
    usecases: ['collateral'],
  },
  {
    name: 'Octoswap',
    url: 'https://octo.exchange/swap?outputCurrency=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A&inputCurrency=nativecoin',
    logo: '/defi/octoswap.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Nitro Finance',
    url: 'https://testapp.nitrofinance.xyz/liquidity/0x019d5357903a8e70209da7a920207666b22ba4f0',
    logo: 'https://i.imgur.com/84SC93n.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Caddy Finance',
    url: 'https://alpha.caddy.finance/options?token=stmon-usd',
    logo: 'https://i.imgur.com/Pyxgm9K.png',
    usecases: ['options'],
  },
  {
    name: 'Clober',
    url: 'https://alpha.clober.io/trade?utm_source=landing_page&utm_medium=landing_page',
    logo: 'https://i.imgur.com/WbJScvR.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Amertis',
    url: 'https://testnet.amertis.exchange/',
    logo: 'https://i.imgur.com/bJx0vdX.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Demask Finance',
    url: 'https://app.demask.finance/pools',
    logo: '/defi/demask.svg',
    usecases: ['collateral'],
  },
  {
    name: 'Enjoyoors',
    url: 'https://app.enjoyoors.xyz/monad/vault/7/token/420/deposit',
    logo: '/defi/enjoy.svg',
    usecases: ['staking'],
  },
  {
    name: 'Castora',
    url: 'https://castora.xyz/pool/1916',
    logo: 'https://i.imgur.com/cpIt47j.jpeg',
    usecases: ['collateral'],
  },
  {
    name: 'Crust',
    url: 'https://testnet.crust.finance/',
    logo: 'https://i.imgur.com/tzc7PeS.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Atlantis',
    url: 'https://app.atlantisdex.xyz/swap/v4/',
    logo: '/defi/atlantis.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Madhouse',
    url: 'https://madhouse.ag/',
    logo: '/defi/madhouse.svg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Crystal',
    url: 'https://app.crystal.exchange/market?tokenIn=0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE&tokenOut=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A&amountIn=0',
    logo: '/defi/crystal.jpg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'PINGU',
    url: 'https://pingu.exchange/trade/AAVE-USD',
    logo: '/defi/pingu-sq.svg',
    usecases: ['collateral', 'lp'],
  },
  {
    name: 'Mace',
    url: 'https://testnet.swaps.mace.ag/',
    logo: '/defi/mace.jpg',
    usecases: ['swap'],
  },
  {
    name: 'Hakifi',
    url: 'https://hakifi.xyz/dapp/swap?from=MON&to=aprMON',
    logo: '/defi/hakifi.png',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Blocklive',
    url: 'https://app.stage.fun/swap',
    logo: '/defi/blocklive.jpg',
    usecases: ['swap', 'lp'],
  },
  {
    name: 'Fukunad',
    url: 'https://testnet.fukunad.xyz/kuro',
    logo: 'https://i.imgur.com/FwdfAcC.jpeg',
    usecases: ['collateral'],
  },
  {
    name: 'OpenOcean',
    url: 'https://app.openocean.finance/swap/monad/WMON/aprMON',
    logo: 'https://i.imgur.com/4dsjcf6.png',
    usecases: ['swap'],
  },
  {
    name: 'Nostra',
    url: 'https://monad.nostra.finance/lend-borrow/aprMON/deposit',
    logo: '/defi/nostra.svg',
    usecases: ['lending/borrowing'],
  },
  {
    name: 'zkSwap Finance',
    url: 'https://www.zkswap.finance/swap?outputCurrency=0xb2f82D0f38dc453D596Ad40A37799446Cc89274A',
    logo: 'https://i.imgur.com/Rl3i6uN.jpeg',
    usecases: ['swap', 'lp'],
  },
];
